import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

// Simple cart item for Supabase products
export interface SimpleCartItem {
  id: string;
  title: string;
  price: number;
  currencyCode: string;
  imageUrl: string | null;
  quantity: number;
}

interface CartStore {
  items: SimpleCartItem[];
  isLoading: boolean;
  
  addItem: (item: Omit<SimpleCartItem, 'quantity'>) => void;
  updateQuantity: (id: string, quantity: number) => void;
  removeItem: (id: string) => void;
  clearCart: () => void;
  setLoading: (loading: boolean) => void;
}

export const useCartStore = create<CartStore>()(
  persist(
    (set, get) => ({
      items: [],
      isLoading: false,

      addItem: (item) => {
        const { items } = get();
        const existingItem = items.find(i => i.id === item.id);
        
        if (existingItem) {
          set({
            items: items.map(i =>
              i.id === item.id
                ? { ...i, quantity: i.quantity + 1 }
                : i
            )
          });
        } else {
          set({ items: [...items, { ...item, quantity: 1 }] });
        }
      },

      updateQuantity: (id, quantity) => {
        if (quantity <= 0) {
          get().removeItem(id);
          return;
        }
        
        set({
          items: get().items.map(item =>
            item.id === id ? { ...item, quantity } : item
          )
        });
      },

      removeItem: (id) => {
        set({
          items: get().items.filter(item => item.id !== id)
        });
      },

      clearCart: () => {
        set({ items: [] });
      },

      setLoading: (isLoading) => set({ isLoading }),
    }),
    {
      name: 'vip-fitness-cart',
      storage: createJSONStorage(() => localStorage),
    }
  )
);